import { all, call, put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchWorkflowsFailure,
  fetchWorkflowsSuccess,
  createWorkflowsSuccess,
  fetchWorkflows,
  createWorkflowsFailure,
  editWorkflowsFailure,
  editWorkflowsSuccess,
  deleteWorkflowsSuccess,
  deleteWorkflowsFailure,
} from './actions';
import workflowsTypes from './types';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { statusCodes } from 'utils/constants';

const { API_BASE_URL } = urls || {};

export async function fetchWorkflowDetails(id) {
  const url = `${API_BASE_URL}/workflow/${id}`;
  return request({ method: 'get', url });
}

export async function saveWorkflowSteps(id, data) {
  const url = `${API_BASE_URL}/workflow/${id}/steps`;
  return request({ method: 'put', url, data });
}

export async function saveWorkflowStepAttachment(id, stepId, data) {
  const url = `${API_BASE_URL}/workflow/${id}/steps/${stepId}/attachments`;
  return request({ method: 'post', url, data });
}

export function* fetchWorkflowsRequest({ payload }) {
  const url = `${API_BASE_URL}/workflow?size=${payload.size}&page=${payload.page}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchWorkflowsSuccess(response.raw));
  } else {
    
    yield put(
      fetchWorkflowsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.status, response.message);
  }
}

export async function fetchWorkflowsRequest2(id) {
  const url = `${API_BASE_URL}/workflow/${id}`;
  return request({ method: 'get', url });
}

function* createWorkflowRequest({ payload, cb }) {
  const url = `${API_BASE_URL}/workflow`;
  
  const response = yield request({
    method: 'post',
    data: payload,
    url,
  });

  if (response.success) {
    yield put(createWorkflowsSuccess());
    yield put(fetchWorkflows());
    cb(response.raw);
  } else {
    yield put(createWorkflowsFailure());
    if (response.statusCode === statusCodes.CONFLICT) {
      networkErrorHandler(response.statusCode, 'Workflow name already exists');
    } else {
      networkErrorHandler(response.statusCode, response.message);
    }
  }
}

function* editWorkflowRequest({ payload, cb, id }) {
  const url = `${API_BASE_URL}/workflow/${id}`;

  const response = yield request({
    method: 'put',
    data: payload,
    url,
  });
  if (response.success) {
    yield put(editWorkflowsSuccess());
    yield put(fetchWorkflows());
    cb();
  } else {
    yield put(editWorkflowsFailure(response.message));
    if (response.statusCode === statusCodes.CONFLICT) {
      networkErrorHandler(response.statusCode, 'Workflow name already exists');
    } else {
      networkErrorHandler(response.statusCode, response.message);
    }
  }
}

function* deleteWorkflowRequest({ id, cb }) {
  const url = `${API_BASE_URL}/workflow/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  if (response.success) {
    yield put(deleteWorkflowsSuccess());
    yield put(fetchWorkflows());
    cb();
  } else {
    yield put(deleteWorkflowsFailure(response.message));
    networkErrorHandler(response.statusCode, response.message);
  }
}

function* onFetchWorkflows() {
  yield takeLatest(
    workflowsTypes.FETCH_WORKFLOWS_REQUEST,
    fetchWorkflowsRequest
  );
}

function* onCreateWorkflow() {
  yield takeLatest(
    workflowsTypes.CREATE_WORKFLOWS_REQUEST,
    createWorkflowRequest
  );
}

function* onEditWorkflow() {
  yield takeLatest(workflowsTypes.EDIT_WORKFLOWS_REQUEST, editWorkflowRequest);
}

function* onDeleteWorkflow() {
  yield takeLatest(
    workflowsTypes.DELETE_WORKFLOWS_REQUEST,
    deleteWorkflowRequest
  );
}

export default function* workflowsSagas() {
  yield all([
    call(onFetchWorkflows),
    call(onCreateWorkflow),
    call(onEditWorkflow),
    call(onDeleteWorkflow),
  ]);
}
